var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFea8(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84 87",
    width: 84,
    height: 87,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fea4-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 90,
    height: 90,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAMAAAAPdrEwAAAAAXNSR0IB2cksfwAAADNQTFRF/487/487/487/487/487/487/487/487/487/487/487/487/487/487/487/487/4871N4pLwAAABF0Uk5T/wAQkNBAUOBggPAwwKCwcCC29q1YAAAB00lEQVR4nO3YbXODIAwAYPDdrmv7/39tr7RVIQl5AXe3O/iwTZY8S6OC07mThz9hNLrRjW70aXTnXH8OPZR9oAw9FjYrk/5dy6fadKh5en2ZK9NhdvFTQUcIev3Ovr4NNelN9gVnEqWPc3Ybo8doqrfaGJ3MXIw2pH+AZOwJoDum9wX0+3pOxjUEKZcqlCbDVJWjtHMXylasKID+perbcGnpMHqlAR1OXtewJ1ocj7zR6fK+EGG5vWvd8JuFZu6SvfSriu5DOLNyTHxjkF871/F1e79wpUN6O+RP1rzrdwF9OJZcBzu+cvTn4aOPP0BuPKiup5NxVPjJKUaGnuMgNZ2etMNMGqNiEzueADF6GvSWou+16AHGFJQdHSIhA8isRhecyONhF4csFek1Dpmxv2ek0ar1ZYt7rbf/mo46Mhpp/Jb5PNslIUqboPct77hr2GS4y4S9IH5Utcmyf/9NcmUay8rT0qUVLShPC8vGk2rQRBJDS2wqp5wmc4ppOoejOTuTUkjnUlh6Usvy93xqWU7TTw1MMTxNls0l2Gk2QUDjNh9vpQXxEvqhkzU0LFsULqJTWxYto71GVtKH+51/EaWk/fuFhugtq54Wj0Y3WkT/t/EECLsWrFDhPq4AAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1021"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Layer 1",
    href: "#img1",
    x: -5,
    y: -1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFea8);
export default __webpack_public_path__ + "static/media/fea8.8e65fc2bf16f838cd16d30523f366ee7.svg";
export { ForwardRef as ReactComponent };